/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DataTable,
  PaginationV2,
  Modal,
  DataTableSkeleton,
} from 'carbon-components-react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import qs from 'qs';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-duplicates
import { Card } from '.';
import LowPriority from './Icons/LowPriority';
import { getDmService, deleteDmService, updateDmService } from '../services/Api';
import appConfig from '../config/app-config';
import { CANCELADO, DEVOLVIDO } from '../config/StatusRequest';
// import moment from 'moment';
// eslint-disable-next-line import/no-duplicates
import { SearchInput } from '.';

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSelectRow,
  TableBody,
  TableCell,
  TableHeader,
  TableToolbarContent
} = DataTable;
const { IMAGE_PATH } = appConfig;

class TableDefault extends Component {
  static propTypes = {
    displayToolbar: PropTypes.bool,
    displayActions: PropTypes.bool,
    onRowSelected: PropTypes.func,
    forbidSelectionOfConflictingTypes: PropTypes.bool
  };

  static defaultProps = {
    displayToolbar: true,
    displayActions: true,
    onRowSelected: null,
    forbidSelectionOfConflictingTypes: false
  };

  constructor(props) {
    super(props);
    this.searchTimeout = null;
    this.hasRun = false;

    this.state = {
      // selectedId: null,
      isLoading: false,
      items: {
        resultado: []
      },
      // orderBy: null,
      deleteModal: false,
      setPageNumber: null,
      setPageSize: null,
      search: '',
      // valueSearch: null,
      page: 1,
      orderByState: '',
      orderDirection: null,
      typeFilter: null,
      totalizador: null,
      urlCurrent: "",
      selectedAll: false,
      width: 0,
      arrayStatusPedido: [
        /*         "Aprovação Comercial", */
        "Aprovação de Arte",
        "Fechamento de Arquivo",
        "Aguardando Produção",
        "Fornecedor",
        "Amostra de Cartão",
        "Disponivel para Retirada",
        "Transporte",
        "Finalizado"
      ]
    };
  }

  componentWillMount() {
    const { onRef } = this.props;

    this.getItems();
    if (onRef) {
      onRef(this);
    }
  }

  componentWillReceiveProps = async (receivProps) => {
    const { urlCurrent } = this.state;
    const { location } = receivProps;
    const newUrl = location.pathname;
    if (newUrl !== urlCurrent) {
      this.setState({
        urlCurrent: newUrl,
        items: {
          resultado: []
        },
      })
      await this.getItems(null, null, receivProps.params);
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  getItems = async (setNumber, setSize, paramsUpdate) => {

    this.setState({ isLoading: true });
    const { typeFilter } = this.state;
    const {
      type,
      typeCleark,
      pageSize,
      orderBy,
      params,
      defaultFilters,
      customDataFilter,
      order,
      urlLoad
    } = this.props;

    const {
      page,
      search,
      orderByState,
      orderDirection,
      selectedCustomFilter,
      customDataFilterValue
    } = this.state;

    const pageNumberDefault = setNumber || page;
    const pageSizeDefault = setSize || pageSize;

    const filters = _.isEmpty(params)
      ? `?busca=${search}&tipo=${typeFilter ||
      type}&tipoAssistente=${typeCleark}${defaultFilters ? `&${defaultFilters}` : ''
      }&ordem=${orderByState !== "" ? orderByState : orderBy}&ordemDirecao=${orderDirection ||
      order ||
      'ASC'}&pageNumber=${pageNumberDefault}&pageSize=${pageSizeDefault}`
      : `?ordem=${orderByState !== "" ? orderByState : orderBy}&ordemDirecao=${orderDirection ||
      order ||
      'ASC'}&pageNumber=${pageNumberDefault}&pageSize=${pageSizeDefault}&${paramsUpdate || params}&${qs.stringify(
        params
      )}`;

    getDmService(
      urlLoad +
      filters +
      (customDataFilter
        ? `&${customDataFilter.id}=${customDataFilterValue}`
        : '')
    )
      .then(data => {
        let totalizador = null;
        let updatedData = data;
        if (data.detalhe) {
          totalizador = data.total;
          updatedData = data.detalhe;
        }

        if (customDataFilter) customDataFilter.selected = selectedCustomFilter;
        // console.log(updatedData)
        this.setState({
          items: updatedData,
          isLoading: false,
          // totalItems: data.totalCount,
          totalizador
        });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  onSearchChange = event => {
    clearTimeout(this.searchTimeout);
    const { value } = event.target;
    this.setState({ search: value, page: 1 });
    this.searchTimeout = setTimeout(() => {
      this.setState(
        {
          search: value,
          page: 1
        },
        () => {
          this.getItems();
        }
      );
    }, 1800);
  };

  actionCustomDataFilter = e => {
    this.setState(
      {
        customDataFilterValue: e.id,
        selectedCustomFilter: e
      },
      () => {
        this.getItems();
      }
    );
  };

  actionFilterTable = event => {
    this.setState(
      {
        typeFilter: event.label,
        selectedFilter: event
      },
      () => {
        this.getItems();
      }
    );
  };

  handleSort = (key, direction) => {
    const { setPageSize } = this.state;
    const { pageSize } = this.props;
    console.log("handle sort test");
    console.log(pageSize);
    console.log(setPageSize)

    this.setState(
      {
        orderByState: key,
        orderDirection: direction,
        page: 1
      },
      () => {
        this.getItems(null, setPageSize, null);
      }
    );
  };

  canRunSort = () => {
    this.setState({ canRun: true });
  };

  customSortRow = (cellA, cellB, { key, sortDirection }) => {
    const { canRun } = this.state;
    if (!(this.state && !canRun) && this.hasRun === false) {
      this.setState({ canRun: false });
      this.hasRun = true;
      this.handleSort(key, sortDirection);
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.hasRun = false;
      }, 100);
    }
  };

  deleteOrder = async row => {
    const { onDelete, urlDelete, filters } = this.props;
    try {
      await deleteDmService(urlDelete, row.id);
      await this.getItems(filters);
      this.toggleModal();
      if (onDelete)
        onDelete();
      toast.success('Item removido com sucesso');
    } catch (e) {
      toast.error('Não foi possível remover o item');
    }
  };

  goEdit(row) {
    const { match, urlGo, editException } = this.props;
    const { path } = match;

    if (editException && path === editException) {
      urlGo(row)
    } else {
      const { urlEdit, history } = this.props;
      if (!urlEdit) return;
      let url = urlEdit + row.id;
      if (urlEdit && urlEdit.indexOf('/:id') > -1)
        url = urlEdit.replace('/:id', `/${row.id}`);
      history.push(url);
    }
  }

  toggleModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
      selectedId: null
    }));
  };

  pagination = pag => {
    this.setState(
      { setPageNumber: pag.page, setPageSize: pag.pageSize },
      () => {
        this.getItems(pag.page, pag.pageSize);
      }
    );
  };

  onDeploymentSelection = (selectedRows, currentRow, selectRow) => {
    const { forbidSelectionOfConflictingTypes, onRowSelected } = this.props;
    let areRowTypesEqual = true;
    if (forbidSelectionOfConflictingTypes) {
      if (selectedRows[0]) {
        const firstRowType = selectedRows[0].cells.find(
          cell => cell.id === `${selectedRows[0].id}:tipo`
        ).value;
        const currentRowType = currentRow.cells.find(
          cell => cell.id === `${currentRow.id}:tipo`
        ).value;
        if (firstRowType !== currentRowType) {
          areRowTypesEqual = false;
        }
      }
    }

    if (areRowTypesEqual) {
      // Se for um tipo válido, adiciona a row aos selectedRows e passa isso para o
      // onRowSelected
      if (!currentRow.isSelected) {
        selectedRows.push(currentRow);
      } else {
        selectedRows = selectedRows.filter(p => p.id !== currentRow.id);
      }

      const result = { ids: [], rows: [] };
      selectedRows.forEach(p => {
        result.ids.push(p.id);
        result.rows.push(p);
      });
      onRowSelected(result);
    } else {
      // Se não, passa um objeto results diferente, mantendo as selectedRows controladas
      // iguais, e passa o result diferente para o onRowSelected só para que apareça o
      // modal de erro.
      const result = { ids: [], rows: [] };
      selectedRows.forEach(p => {
        result.ids.push(p.id);
        result.rows.push(p);
      });
      result.ids.push(currentRow.id);
      result.rows.push(currentRow);
      onRowSelected(result);
      // Desseleciona o currentRow
      selectRow(currentRow.id);
    }
  };

  setSelectedAll = (rows, selectRow, selectedRows) => {
    this.setState(prevState => ({
      selectedAll: !prevState.selectedAll
    }), () => {
      this.onSelectedAll(rows, selectRow, selectedRows)
    })
  }

  clearSelectAll = () => {
    this.setState({ selectedAll: false })
  }

  onSelectedAll = (rows) => {
    const { onRowSelected } = this.props;
    const { selectedAll } = this.state;
    const result = { ids: [], rows: [] };
    for (const item of rows) {
      result.ids.push(item.id);
      result.rows.push(item)
    }

    if (selectedAll) {
      onRowSelected(result);
    } else {

      for (const item of rows) {
        result.ids.pop(item.id)
        result.rows.pop(item)
      }
      onRowSelected(result);
    }

  }

  statusAlert = (row, currentPage, obj) => {
    //  if (currentPage === 'criacao' || currentPage === 'triagem') {
    const { cells } = row;

    let className = "";
    cells.forEach(cell => {
      if (cell && cell.info.header === 'statusAnterior') {
        if (cell.value === 'Devolvido' ||
          (cell.value === 'Devolvido' && currentPage === 'criacao')) {
          className = " statusAlertPurple";
          // console.log(className);
        } else if (obj.motivoPrioridade !== "" && obj.motivoPrioridade !== null) {
          className = " statusAlertRed";
        } else if (obj.prioridade === 'Sim' || cell.value === 'Sim') {
          className = " statusAlertRed";
        }

      }

      if (obj.statusAtual === 'Devolvido' || cell.value === 'Devolvido') {
        className = " statusAlertPurple";
        // console.log(className);
      }

      // statusAlertYellow
      if (currentPage === 'criacao' || currentPage === 'triagem' || currentPage === 'triagemAudioVisual' || currentPage === 'supervisaoTrade' || currentPage === 'devolvido' || currentPage === 'redacao' || currentPage === 'aprovacaoDeArte') {
        //  console.log(currentPage);
        if (
          ((obj.statusAtual === 'Devolvido' || cell.value === 'Devolvido') ||
          (obj.statusAtual === 'Triagem' || cell.value === 'Triagem') ||
          (obj.statusAtual === 'Triagem Áudio Visual' || cell.value === 'Triagem Áudio Visual') ||
          (obj.statusAtual === 'Criação' || cell.value === 'Criação') ||
          (obj.statusAtual === 'Redação' || cell.value === 'Redação') ) && (obj.criarTextoRedacao === 1)
        ) {
          
          className = " statusAlertYellow";
        }
      }
    })

    return className;
    // }
    // return ''
  }

  checkStatus = (row) => {
    const cell = row.cells.find(x => x.id.includes(':status')).value;
    let status = false;
    if (cell === "Ativo" || cell === "Disponível") {
      status = true;
    }
    return status;
  }

  editProduct = (row) => {
    const status = row.cells.find(x => x.id.includes(':status')).value;
    const ativo = this.checkStatus(row);
    const url = window.location.pathname.split("/")[3] === '1' ? '/ProdutoAgencia/AlteraStatus' : '/Produto/AlteraStatus';
    updateDmService(url, row.id, null)
    // .then(data => {

    // })
    // .catch(() => {
    //   alert("Erro");
    // });
    if (ativo) {
      row.cells.find(x => x.id.includes(':status')).value = status === 'Ativo' ? 'Inativo' : 'Indisponível';
    }
    else {
      row.cells.find(x => x.id.includes(':status')).value = status === 'Inativo' ? 'Ativo' : 'Disponível';
    }

    this.setState({ row });

    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  render() {
    const {
      items,
      isLoading,
      setPageSize,
      setPageNumber,
      search,
      modalHeading,
      primaryButtonText,
      modalMessage,
      deleteModal,
      selectedFilter,
      selectedCustomFilter,
      totalizador,
      width
    } = this.state;

    const {
      page,
      pageSize,
      extraRows,
      urlDelete,
      actionNext,
      dataFilter,
      customDataFilter,
      displayToolbar,
      displayActions,
      onRowSelected,
      filters,
      renderFilters,
      notSearch,
      deleteMessage,
      currentPage,
      enableProduct,
    } = this.props;

    if (isLoading && (items && !items.header)) {
      return <DataTableSkeleton rowCount={10} />;
    }

    return (
      <div>
        <DataTable
          rows={items && items.resultado ? items.resultado : []}
          sortRow={this.customSortRow}
          headers={items && items.header ? items.header : []}
          render={({
            rows,
            headers,
            getHeaderProps,
            getSelectionProps,
            selectedRows,
            selectRow,
          }) => {
            this.selectRow = selectRow;
            this.selectedRows = selectedRows;

            return (
              <TableContainer>
                {displayToolbar && (
                  <TableToolbarContent>
                    {!notSearch && (
                      <SearchInput
                        value={search}
                        onChange={e => this.onSearchChange(e)}
                        placeholder="Filtrar tabela"
                      />
                    )}
                    {renderFilters}
                    {dataFilter && (
                      <Select
                        name="filter"
                        className="filter-table"
                        options={dataFilter.itens}
                        value={selectedFilter}
                        onChange={e => this.actionFilterTable(e)}
                        placeholder={dataFilter.placeholder}
                      />
                    )}
                    {customDataFilter && (
                      <Select
                        name="filter"
                        className="filter-table"
                        options={customDataFilter.itens}
                        value={
                          selectedCustomFilter || customDataFilter.selected
                        }
                        onChange={e =>
                          this.actionCustomDataFilter(e, customDataFilter.id)
                        }
                        placeholder={customDataFilter.placeholder}
                      />
                    )}
                  </TableToolbarContent>
                )}
                <Table className="responsive-carbon-table">
                  <TableHead>
                    <TableRow className={typeof onRowSelected === 'function' ? "TableSelectRow" : ""}>
                      {typeof onRowSelected === 'function' && (
                        <TableSelectRow
                          {...getSelectionProps({
                            onClick: () => {
                              this.setSelectedAll(rows, selectRow, selectedRows);
                            }
                          })}
                        />
                      )}
                      {width < 1050 && (<TableHeader />)}
                      {/* cabeçalho da tabela */}
                      {width >= 1050 && headers.map(header => (
                        <TableHeader
                          {...getHeaderProps({
                            header,
                            onClick: this.canRunSort
                          })}
                          style={{ width: "auto", float: header.align || 'left' }}
                        >
                          <span>{header.key === "qntProdutos" ? "Qtd" : header.header}</span>
                        </TableHeader>
                      ))}
                      {enableProduct ? (
                        <TableHeader>Habilitar</TableHeader>
                      ) : ''}
                      {(displayActions && (extraRows || urlDelete)) && <th />}
                    </TableRow>
                  </TableHead>
                  {!items.resultado.length ? (
                    <TableBody>
                      <tr>
                        <td colSpan={headers.length + 1}>
                          <div className="font-size-13">
                            Nenhum registro encontrado.
                          </div>
                        </td>
                      </tr>
                    </TableBody>
                  ) : (
                    <TableBody>
                      {rows.map(row => (
                        <TableRow className={`${typeof onRowSelected === 'function' ? "TableSelectRow" : ""}${this.statusAlert(row, currentPage, items.resultado.find(item => item.id === row.id))}`} key={row.id}>
                          {typeof onRowSelected === 'function' && (
                            <TableSelectRow
                              className="TableSelectRow"
                              {...getSelectionProps({
                                row,
                                onClick: () => {
                                  this.onDeploymentSelection(
                                    selectedRows,
                                    row,
                                    selectRow
                                  );
                                }
                              })}
                            />
                          )}
                          {(width < 1050 && ( // Monta o card
                            // (width < 1165 && document.body.classList[0] === 'nav-actived') || (width < 1050 && !document.body.classList[0] === 'nav-actived') )
                            <TableCell
                              key={`row-${row.id}`}
                              className="pointer"
                              onClick={() => this.goEdit(row)}
                            >
                              <Card className="table-card">
                                {row.cells.map(cell => (
                                  <div>
                                    {cell.info.header.toLowerCase() === 'foto' ? (
                                      <div>
                                        {cell.value !== "" ? (
                                          <img
                                            className="img-responsive"
                                            alt="img-responsive"
                                            src={IMAGE_PATH + cell.value}
                                          />
                                        ) : (
                                          <i className="material-icons">image</i>
                                        )}
                                      </div>
                                    ) : cell.info.header === 'pendenteAcao' ?
                                      (cell.value === "0" ? (
                                        <span className="warning-icon-color">
                                          <i className="material-icons">warning</i>
                                        </span>
                                      ) : <span>{cell.value}</span>
                                      ) : cell.info.header === 'status' && this.props.isInterno ? (
                                        null
                                      ) : (
                                        <p>
                                          {headers.find(obj => obj.key === cell.info.header).header}
                                          :
                                          <strong>{` ${cell.value || ""}`}</strong>
                                        </p>
                                      )
                                    }
                                  </div>
                                ))}
                                {/* {JSON.stringify(item)} */}
                              </Card>
                            </TableCell>
                          ))}
                          {/* células da tabela */}
                          {width >= 1050 && row.cells.map(cell => { // Esconde as outras células
                            const headerObj = headers.find(obj => obj.key === cell.info.header);
                            return (
                              this.props.isInterno && cell.info.header === "status" ?
                                (this.state.arrayStatusPedido.indexOf(cell.value) === -1 ? (
                                  <TableCell
                                    key={cell.id}
                                    className="pointer"
                                    style={{ textAlign: headerObj.align || 'left' }}
                                    onClick={() => this.goEdit(row)}
                                  />
                                ) : (
                                  <TableCell
                                    key={cell.id}
                                    className="pointer"
                                    style={{ textAlign: headerObj.align || 'left' }}
                                    onClick={() => this.goEdit(row)}
                                  >
                                    {cell.value}
                                  </TableCell>
                                )) : (
                                  <TableCell
                                    key={cell.id}
                                    className="pointer"
                                    style={{ textAlign: headerObj.align || 'left' }}
                                    onClick={() => this.goEdit(row)}
                                  >
                                    {!_.isArray(cell.value) ? (
                                      cell.info.header.toLowerCase() === 'foto' ? (
                                        <div>
                                          {cell.value !== "" ? (
                                            <img
                                              className="img-responsive"
                                              alt="img-responsive"
                                              src={IMAGE_PATH + cell.value}
                                            />
                                          ) : (
                                            <i className="material-icons">image</i>
                                          )}
                                        </div>
                                      ) : cell.info.header === 'pendenteAcao' ?
                                        (cell.value === "0" ? (
                                          <span className="warning-icon-color">
                                            <i className="material-icons">warning</i>
                                          </span>
                                        ) : <span>{cell.value}</span>) : cell.value
                                    ) : null}
                                  </TableCell>
                                )
                            );
                          })}
                          {displayActions && (
                            <td className="td-actions">
                              {extraRows &&
                                extraRows.map(cell => (
                                  <button
                                    type="submit"
                                    onClick={() => {
                                      this.btnAction = async () => {
                                        try {
                                          await cell.action(row.id);
                                          await this.getItems(filters);
                                          this.toggleModal();
                                          toast.success(cell.successMessage);
                                        } catch (e) {
                                          toast.error(cell.errorMessage);
                                        }
                                      };
                                      this.setState(
                                        {
                                          modalHeading: cell.modalHeading,
                                          primaryButtonText: 'Tenho certeza',
                                          modalMessage: cell.modalMessage
                                        },
                                        () => {
                                          this.toggleModal();
                                        }
                                      );
                                    }}
                                    className="button button--clear h-sm-margin sm-padding pointer"
                                  >
                                    <i className="material-icons">
                                      {cell.icon}
                                    </i>
                                  </button>
                                ))}

                              {urlDelete && (
                                <button
                                  type="submit"
                                  onClick={() => {
                                    this.btnAction = () =>
                                      this.deleteOrder(row);
                                    this.setState(
                                      {
                                        // selectedId: row.id,
                                        modalHeading: 'Remover Item',
                                        primaryButtonText: 'Tenho certeza',
                                        modalMessage:
                                          deleteMessage || 'Você tem certeza que deseja deletar este item?'
                                      },
                                      () => {
                                        this.toggleModal();
                                      }
                                    );
                                  }}
                                  className="button button--clear danger  pointer f-right"
                                >
                                  <i className="material-icons">
                                    delete_outline
                                  </i>
                                </button>
                              )}

                              {actionNext &&
                                row.cells.find(cell =>
                                  cell.id.includes(':status')
                                ).value !== CANCELADO.value &&
                                row.cells.find(cell =>
                                  cell.id.includes(':status')
                                ).value !== DEVOLVIDO.value && (
                                  <button
                                    type="submit"
                                    onClick={() => actionNext(row)}
                                    className="button button--clear  pointer f-left scaleY next-page"
                                  >
                                    <LowPriority />
                                  </button>
                                )}
                            </td>
                          )}
                          {enableProduct && (
                            <td className="td-actions">
                              {row.cells.find(cell => cell.id.includes(':status')).value ? (
                                <input type="checkbox" defaultChecked={this.checkStatus(row)} onClick={() => this.editProduct(row)} />
                              ) : ''}
                            </td>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
                <PaginationV2
                  page={setPageNumber || page}
                  pageSize={setPageSize || pageSize}
                  onChange={e => this.pagination(e)}
                  pageSizes={[10, 50, 100]}
                  itemsPerPageText="Itens por página"
                  totalItems={items.totalCount}
                />
              </TableContainer>
            );
          }}
        />
        {totalizador && (
          <div className="totalizador">
            {'Total: '}
            <strong>{totalizador}</strong>
          </div>
        )}
        {deleteModal && (
          <Modal
            open={deleteModal}
            onRequestSubmit={this.btnAction}
            onRequestClose={this.toggleModal}
            modalHeading={modalHeading}
            primaryButtonText={primaryButtonText}
            secondaryButtonText="Cancelar"
          >
            <div className="warning-modal-txt">
              <p>{modalMessage}</p>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

const TableDefaultWithRouter = withRouter(TableDefault);

export default TableDefaultWithRouter;



// WEBPACK FOOTER //
// ./src/components/TableDefault.js